import { CollapsiblePanel, Panel } from "../../../widgets";
import { ControlType, Property, PropertyType } from "../../../base/types";

import { DesignerMode } from "../../types";
import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { useGetProperties } from "../../../base/hooks";

export const PanelComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const title: string | undefined = properties[Property.Title]
    const headerClass: string | undefined = properties[Property.HeaderClass]
    const collapsible: boolean | undefined = properties[Property.Collapsible]
    const icon: string | undefined = properties[Property.MaterialIcon]
    const hidden: boolean | undefined = properties[Property.Hidden]
    const tooltip: string | undefined = properties[Property.Tooltip];

    if (designerMode === DesignerMode.View && hidden === true) {
        return <></>
    }

    if (collapsible) {
        return (
            <CollapsiblePanel
                eventKey="chat-component"
                className={className}
                header={title}
                title={tooltip}
                icon={icon}
                headerClass={headerClass}
            >
                {children}
            </CollapsiblePanel>
        )
    }

    return (
        <Panel
            className={className}
            header={title}
            title={tooltip}
            icon={icon}
            headerClass={headerClass}>
            {children}
        </Panel>)
}

Registry.addControl({
    id: "56b57dc2-f9a3-4f78-8d5a-6f9c6fc67ed3",
    name: "Panel",
    type: ControlType.Panel,
    properties: [
        { id: Property.Title, name: 'Title', type: PropertyType.String },
        { id: Property.Collapsible, name: 'Collapsible', type: PropertyType.Boolean },
        { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
        { id: Property.HeaderClass, name: 'Header Class', type: PropertyType.String },
        { id: Property.Hidden, name: 'Hidden', type: PropertyType.Boolean },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
    ],
    component: PanelComponent
})
